import React from "react";
import { Box, Container } from "@mui/material";

interface PageLayoutProps {
  children: React.ReactNode;
  dir: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ dir, children }) => {
  return (
    <Container dir={dir} maxWidth={false} disableGutters>
      <Box>{children}</Box>
    </Container>
  );
};

export default PageLayout;
